import React, { useState } from 'react';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { Container, Paper, Box, Typography, Avatar } from '@material-ui/core';
import { Users } from 'lucide-react';
import TreeNode from './TreeNode';
import Header from './Header';
// import { getRoleColor, getRoleIcon } from '../utils';

export default function AgentHierarchy() {
  const [tree, setTree] = useState({
    id: 'gm1',
    name: 'GENERAL MANAGER',
    role: 'GM',
    children: [
      {
        id: 'csm1',
        name: 'CSM 1',
        role: 'CSM',
        children: [
          {
            id: 'bdm1',
            name: 'BUSINESS DEVELOPMENT MANAGER 1',
            role: 'BDM',
            children: [
              {
                id: 'um1',
                name: 'UNIT MANAGER 1',
                role: 'UM',
                children: [
                  { id: 's1', name: 'SALES PERSON 1', role: 'SP', children: [] },
                  { id: 's2', name: 'SALES PERSON 2', role: 'SP', children: [] },
                  { id: 's3', name: 'SALES PERSON 3', role: 'SP', children: [] },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'csm2',
        name: 'CSM 2',
        role: 'CSM',
        children: [
          {
            id: 'bdm2',
            name: 'BUSINESS DEVELOPMENT MANAGER 2',
            role: 'BDM',
            children: [
              {
                id: 'um2',
                name: 'UNIT MANAGER 2',
                role: 'UM',
                children: [
                  { id: 's4', name: 'SALES PERSON 4', role: 'SP', children: [] },
                  { id: 's5', name: 'SALES PERSON 5', role: 'SP', children: [] },
                  { id: 's6', name: 'SALES PERSON 6', role: 'SP', children: [] },
                ],
              },
            ],
          },
        ],
      },
    ],
  });

  const [activeId, setActiveId] = useState(null);
  const [draggedNode, setDraggedNode] = useState(null);

  const handleAddChild = (parentId, name, role) => {
    const addRecursively = node => {
      if (node.id === parentId) {
        return {
          ...node,
          children: [
            ...node.children,
            {
              id: Date.now().toString(),
              name: name.toUpperCase(),
              role: role,
              children: [],
            },
          ],
        };
      } else {
        return {
          ...node,
          children: node.children.map(addRecursively),
        };
      }
    };
    setTree(addRecursively(tree));
  };

  const findNodeById = (node, id) => {
    if (node.id === id) return node;
    for (const child of node.children) {
      const found = findNodeById(child, id);
      if (found) return found;
    }
    return null;
  };

  const removeNodeById = (node, id) => {
    return {
      ...node,
      children: node.children.filter(child => child.id !== id).map(child => removeNodeById(child, id)),
    };
  };

  const handleDragStart = event => {
    const { active } = event;
    setActiveId(active.id);
    const node = findNodeById(tree, active.id);
    setDraggedNode(node);
  };

  const handleDragEnd = event => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const draggedId = active.id;
      const targetId = over.id.startsWith('drop-') ? over.id.slice(5) : over.id;

      if (draggedId !== targetId) {
        const draggedNode = findNodeById(tree, draggedId);
        if (draggedNode) {
          const treeWithoutDragged = removeNodeById(tree, draggedId);

          const addToTarget = node => {
            if (node.id === targetId) {
              return {
                ...node,
                children: [...node.children, draggedNode],
              };
            } else {
              return {
                ...node,
                children: node.children.map(addToTarget),
              };
            }
          };

          setTree(addToTarget(treeWithoutDragged));
        }
      }
    }

    setActiveId(null);
    setDraggedNode(null);
  };

  return (
    <Box style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* <Header /> */}

      <Container maxWidth="lg" style={{ padding: '32px 0' }}>
        <Paper elevation={3} style={{ borderRadius: 16, overflow: 'hidden' }}>
          <Box style={{ backgroundColor: '#eee', padding: 16, borderBottom: '1px solid #ddd' }}>
            <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Avatar style={{ backgroundColor: '#bbdefb', color: '#1565c0', width: 32, height: 32 }}>
                <Users size={18} />
              </Avatar>
              Organization Chart
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Drag agents to reorganize • Click + to add team members • Use role-specific buttons
            </Typography>
          </Box>

          <Box style={{ padding: 24 }}>
            <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
              <TreeNode node={tree} onAddChild={handleAddChild} onMoveNode={() => {}} level={0} />
              <DragOverlay>
                {activeId && draggedNode ? (
                  <Paper elevation={6} style={{ padding: 8, borderRadius: 8 }}>
                    {draggedNode.name}
                  </Paper>
                ) : null}
              </DragOverlay>
            </DndContext>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
